import { Component, Inject } from '@angular/core';
import { QrCode } from '../../../../models/qr-codes.model';
import { TableElementComponent } from '@uranda/ui';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QrCodeModalComponent } from '../qr-code-modal/qr-code-modal.component';
import { LocalizedRouterService } from '../../../../localized-router.service';

@Component({
  selector: 'app-link-partner-button',
  templateUrl: './link-partner-button.component.html',
  styleUrls: ['./link-partner-button.component.css'],
  standalone: false
})
export class LinkPartnerButtonComponent extends TableElementComponent {
  onLinkClick?: (data: QrCode) => void;
  isLoading = false;

  constructor(
    @Inject('props') public override props: any,
    private modalService: NgbModal,
    private localizedRouter: LocalizedRouterService

  ) {
    super(props);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.onLinkClick = this.props.onClick;

    if (this.data?.partner) {
      this.isLoading = true;
    } else {
      this.isLoading = false;
    }
  }

  onQrLoaded(): void {
    this.isLoading = false;
  }


  handleLinkClick(event: MouseEvent): void {
    event.stopPropagation();
    this.onLinkClick?.(this.data);
  }

  getQrCodeUrl(): string {
    if (this.data?.partner?.id) {
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const qrData = `${baseUrl}/${this.localizedRouter.getCurrentLang()}/qr/${this.data.partner.id}`;
      return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrData)}`;
    }
    return '';
  }

  openQrCodeModal(event: MouseEvent): void {
    event.stopPropagation();

    if (this.data?.partner) {
      const modalRef = this.modalService.open(QrCodeModalComponent, {
        backdrop: true,
        centered: false,
        size: 'lg',
      });

      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const qrData = `${baseUrl}/${this.localizedRouter.getCurrentLang()}/qr/${this.data.partner.id}`;

      modalRef.componentInstance.qrCodeData = qrData;
      modalRef.componentInstance.partnerName = this.data.partner.name;
    }
  }
}